module.exports = __webpack_public_path__ + "img/text.2a34427c.png";